import { Organization } from 'web/model/Organization';

/**
 * Computes the index-route ("/") landing path for a user.
 *
 * This runs during the very first render of <App/>, where the org store may not
 * be hydrated yet (currentOrganization === null). Callers must pass the org
 * resolved *synchronously* from INIT_USER for that first pass — otherwise a
 * Hypercare-type member is briefly redirected to /patients and the pathname is
 * no longer '/', so nothing can correct it afterwards. See resolveInitialOrganization.
 */
export const landingRouteFor = (
    isAdmin: boolean,
    organization: Organization | null,
): string => {
    if (isAdmin) {
        return 'device-data';
    }
    if (organization?.orgHasHypercareEnabled) {
        return 'hypercare';
    }
    return 'patients';
};
